import { Contextify } from './Contextify';

export { Contextify };
export default Contextify;
